import React from 'react';
import { node, oneOf } from 'prop-types';
import { activityCategoriesUnionType } from '@paddl/utils-js';
import { useWidth } from '../..';
import { ContentWrapper } from './ActivityMediaWrapper.styles';
export const ActivityMediaWrapper = _ref => {
  let {
    children,
    category
  } = _ref;
  const width = useWidth();
  return /*#__PURE__*/React.createElement(ContentWrapper, {
    breakpoint: width,
    category: category
  }, children);
};
ActivityMediaWrapper.propTypes = {
  category: oneOf([...activityCategoriesUnionType]).isRequired,
  children: node.isRequired
};